export default __webpack_public_path__ + "static/formazione-aziendale-perche-e-importante-d600577407234d1f74b1761cf8c3954d.jpg";